import { useContext } from 'react';
import CartContext from '../context/CartContext';

export default () => useContext(CartContext);